/* =========================================================================
   AOD AUTO GIFT
   -------------------------------------------------------------------------
   Jab customer koi "stock in hand" (variant metafield custom.in_hand_inventory
   ki value 1 se 6 ke beech) wala eligible product cart me add kare, to yeh
   script neeche di gayi GIFT SKU ki variant ko automatically 1 quantity me
   cart me add kar deta hai.
 
   - Gift SKU ka apna stock Shopify se live check hota hai (native inventory
     tracking) — agar gift ka stock 0 ho jaye, to auto-add khud-ba-khud
     ruk jata hai. Jab dobara restock ho, khud start ho jayega.
   - Agar customer eligible product ko cart se hata de, to gift bhi
     automatically cart se remove ho jata hai.
   - Ek se zyada baar gift add nahi hota (line item property se track hota
     hai), chahe customer kitni baar bhi eligible product add/remove kare.
   ========================================================================= */
(function () {
  "use strict";
 
  // Guard against this script accidentally being included/executed more
  // than once on the same page (e.g. a duplicate <script> tag from an app
  // or a theme include). Without this, two independent copies of the
  // script would each keep their own state and could both try to add the
  // gift at the same time, resulting in it being added twice.
  if (window.__aodAutoGiftLoaded) return;
  window.__aodAutoGiftLoaded = true;
 
  /* =========================================================================
     >>>>>>>>>>>>>>>>>>>>>>>>>  YAHAN APNI VALUE DALEIN  <<<<<<<<<<<<<<<<<<<<<<
     Gift wali product/variant ka numeric Variant ID neeche daalein.
     (Shopify Admin > Products > [gift product] > variant ke URL me
     ".../variants/XXXXXXXXXXXX" — yeh last number hai)
     ========================================================================= */
  var GIFT_VARIANT_ID = 43222871703630; // <-- REPLACE THIS WITH THE REAL VARIANT ID (number, no quotes)
  /* ========================================================================= */
 
  var GIFT_PROPERTY_KEY = "_aod_auto_gift";
  var isSyncing = false;
  var pendingResync = false;
 
  function eligibleVariantMap() {
    return window.aodGiftEligibleVariants || {};
  }
 
  function apiUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return root + path;
  }
 
  async function fetchCart() {
    var res = await fetch(apiUrl("cart.js"), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    return res.json();
  }
 
  function findGiftLines(cart) {
    // Any line matching the gift variant counts — whether it was added by
    // this script or manually by the customer — so we never end up with
    // more than one gift in the cart for any reason.
    return cart.items.filter(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }
 
  function cartHasEligibleProduct(cart) {
    var eligible = eligibleVariantMap();
    return cart.items.some(function (item) {
      return item.variant_id !== GIFT_VARIANT_ID && eligible[item.variant_id];
    });
  }
 
  async function isGiftInStock() {
    try {
      var res = await fetch(apiUrl("variants/" + GIFT_VARIANT_ID + ".js"), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) return false;
      var variant = await res.json();
      return !!variant.available;
    } catch (e) {
      return false;
    }
  }
 
  async function addGift() {
    var res = await fetch(apiUrl("cart/add.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              // Underscore prefix hides this property from the cart UI in Dawn-based themes
              _aod_auto_gift: "true",
            },
          },
        ],
      }),
    });
    return res.ok;
  }
 
  async function setLineQuantity(line, quantity) {
    await fetch(apiUrl("cart/change.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: line.key, quantity: quantity }),
    });
  }
 
  async function syncGift() {
    if (!GIFT_VARIANT_ID) return; // not configured yet
    if (isSyncing) {
      pendingResync = true;
      return;
    }
    isSyncing = true;
    try {
      var cart = await fetchCart();
      var hasEligible = cartHasEligibleProduct(cart);
      var giftLines = findGiftLines(cart);
      var totalGiftQty = giftLines.reduce(function (sum, l) { return sum + l.quantity; }, 0);
      var changed = false;
 
      if (hasEligible) {
        if (totalGiftQty === 0) {
          var inStock = await isGiftInStock();
          if (inStock) {
            changed = await addGift();
          }
        } else if (totalGiftQty > 1 || giftLines.length > 1) {
          // Something caused more than one gift to end up in the cart
          // (a race, a duplicate script run, or the customer adding it
          // manually as well). Trim it back down to exactly one.
          for (var i = 0; i < giftLines.length; i++) {
            await setLineQuantity(giftLines[i], i === 0 ? 1 : 0);
          }
          changed = true;
        }
      } else if (totalGiftQty > 0) {
        for (var j = 0; j < giftLines.length; j++) {
          await setLineQuantity(giftLines[j], 0);
        }
        changed = true;
      }
 
      if (changed) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (e) {
      // Fail silently — never block the customer's normal cart flow
      console.error("aod-auto-gift error:", e);
    } finally {
      isSyncing = false;
      if (pendingResync) {
        pendingResync = false;
        syncGift();
      }
    }
  }
 
  // Fires after any add-to-cart, quantity change, or line item removal
  document.addEventListener("cart:change", syncGift);
 
  // Also check once on page load (covers cart page qty edits/removals
  // that may not always redispatch cart:change in every theme flow)
  document.addEventListener("DOMContentLoaded", syncGift);
})();